// 获取表格最大高度，避免页面出现双滚动条，表格最大高度 = 页面高度 - 表格至页面顶部的距离 - 表格至页面底部的距离
// 默认页面基本结构是 TODO ：表格上内容（类似 面包屑header、搜索块）、表格、表格下分页组件、页面含有上下padding
export function useTableMaxHeight() {
  const minHeight = 300
  const bottomMarginHeight = 20 //页面底部margin
  const elCardPaddingBottom = 20 //表格放在 el-card 内，底部的 padding，顶部的 padding 计算在 tableTop
  const paginationHeight = 32 + 20 + 20 //分页组件 + 分页组件上下margin
  const otherHeight = 3 //预留各种boder占位高度
  let inElCard = false //表格是否放在 el-card 内
  let windowHeight = 0
  if (window.innerHeight) {
    windowHeight = window.innerHeight
  }
  if (!windowHeight && document.documentElement?.clientHeight) {
    windowHeight = document.documentElement.clientHeight
  }
  let tableTop = 240 //表格距页面顶部的距离
  let tableDom: any = Array.from(document.querySelectorAll('.el-table')).find((tableItem: any) => {
    return tableItem?.offsetParent !== null // 筛选第一个可见的 el-table
  })
  let node = tableDom
  if (tableDom) {
    tableTop = tableDom.offsetTop
    while (node.offsetParent) {
      node = node.offsetParent
      tableTop += node.offsetTop
      if (node.className.indexOf('el-card') != -1) {
        inElCard = true
      }
    }
  }
  let maxHeight = windowHeight - tableTop - bottomMarginHeight - otherHeight
  // 判断不严谨 TODO
  let paginationDom = Array.from(document.querySelectorAll('.el-pagination')).find((tableItem: any) => {
    return tableItem?.offsetParent !== null // 筛选第一个可见的 el-pagination
  })
  if (paginationDom) {
    // 分页组件、分页组件上下间距
    maxHeight = maxHeight - paginationHeight
  } else {
    // maxHeight = maxHeight + 1 //遮盖底边
    // 无分页组件时，表格放在 el-card 内，底部 pading
    if (inElCard) {
      maxHeight = maxHeight - elCardPaddingBottom
    }
  }
  // console.log('windowHeight', windowHeight, 'tableTop ', tableTop, 'maxHeight ', maxHeight, 'inElCard', inElCard)
  return maxHeight < minHeight ? minHeight : maxHeight
}
